export const env = {
  // Build
  NG_APP_BUILD_ID: "20261031070018-a3627e25",

  // Mission Configuration
  NG_APP_MISSION_ID: "espana",
  NG_APP_MISSION_NAME: "MMM España",
  NG_APP_APP_TYPE: "iglesia",
  
  // Firebase Configuration
  NG_APP_FIREBASE_API_KEY: "AIzaSyDJ_emZ3CJZl9YcmoHwHFZ90rFaHjn41PI",
  NG_APP_FIREBASE_AUTH_DOMAIN: "movimientoespana.firebaseapp.com",
  NG_APP_FIREBASE_PROJECT_ID: "movimientoespana",
  NG_APP_FIREBASE_STORAGE_BUCKET: "movimientoespana.firebasestorage.app",
  NG_APP_FIREBASE_MESSAGING_SENDER_ID: "134321490128",
  NG_APP_FIREBASE_APP_ID: "1:134321490128:web:04efc2dd2c52b7c9dfb6d5",
  NG_APP_FIREBASE_MEASUREMENT_ID: "G-XXXXXXX",
  NG_APP_FUNCTIONS_REGION: "us-central1"
} as const;